// extracted by mini-css-extract-plugin
export default {"sectionItemStyle":"MessagesListDefaultItem_sectionItemStyle__zZf1k","textTextStyle":"MessagesListDefaultItem_textTextStyle__UtdUj"};